// Stock earnings date helpers used by the quote page components
// (stock-earnings.vue relies on Nuxt auto-import, stock-faq.vue imports
// explicitly from "@/utils/stock-date").

const formatEarningsDate = (dateString) => {
	if (!dateString) {
		return "TBD";
	}
	const date = new Date(dateString);
	const day = date.getDate().toString().padStart(2, "0");
	const month = date.toLocaleDateString("en-US", { month: "short" });
	const year = date.getFullYear();
	const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
	return `Confirmed for ${dayOfWeek} ${month} ${day}/${year} After Market`;
};

const isDateTodayOrFuture = (dateString) => {
	if (!dateString || dateString === "Data not provided") {
		return false;
	}
	const today = new Date();
	today.setHours(0, 0, 0, 0);

	const earningsDate = new Date(dateString);
	earningsDate.setHours(0, 0, 0, 0);

	return earningsDate >= today;
};

export { isDateTodayOrFuture, formatEarningsDate };
